module.exports = __webpack_public_path__ + "static/media/social-likes.a303b0d8.svg";